
class ProductModal
extends ModalDialog {

    hide (){
        super.hide()
        window.pauseAllMedia()
    }

    show ( opener , details ){
        super.show(opener,details)
        this.showActiveMedia(details)
    }

    showActiveMedia (details){

        console.debug('ShowActiveModal')

        const origin = this.openedBy

        const { mediaId } = origin.dataset

        const matchMedia = `[ data-media-id = '${ mediaId }' ]`

        const unmatchMedia = `[ data-media-id ]:not(${ matchMedia })`

        this
        .querySelectorAll(unmatchMedia)
        .forEach(( element ) => {
            element.classList.remove('is-active')
        })

        const active = this
            .querySelector(matchMedia)

        console.debug('Active',active,{
            width : active.scrollWidth ,
            height : active.scrollHeight
        })

        const template = active
            .querySelector('template')

        const content = template
            ? template.content : null

        active.classList.add('is-active')

        const container = this
            .querySelector(`[ role = document ]`)

        // container.scrollLeft = ( active.width - container.clientWidth ) / 2

        const x =
            active.offsetLeft +
            details.x.ratio * active.scrollWidth -
            0.5 * window.innerWidth

        const y =
            active.offsetTop +
            details.y.ratio * active.scrollHeight -
            0.5 * window.innerHeight

        console.debug('Scroll To',{ x , y })

        container.scrollTo({
            behavior : 'instant' ,
            left : x ,
            top : y
        })


        if(
            active.nodeName == 'DEFERRED-MEDIA' &&
            content?.querySelector('.js-youtube')
        )   active.loadContent()
    }
}


customElements.define(
    'product-modal' ,
    ProductModal
)
